var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.442,
    height: 68.148,
    viewBox: "0 0 64.442 68.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_42",
    "data-name": "Komponente 10 \\u2013 42",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nutrition",
    transform: "translate(-15.078 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35555",
    "data-name": "Gruppe 35555",
    transform: "translate(15.078 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46846",
    "data-name": "Pfad 46846",
    d: "M69.263,38.511a1.425,1.425,0,0,0-1.018-.431H64.1a19.065,19.065,0,0,0-3.935-16.445.85.85,0,0,0-1.306,1.088,17.4,17.4,0,0,1,4,10.267H46.35V16.48A17.187,17.187,0,0,1,56.139,20.1a.85.85,0,0,0,1.041-1.343,19.069,19.069,0,0,0-16.112-3.47V12.146A22.137,22.137,0,0,1,67.643,33.839a.85.85,0,1,0,1.7,0A23.84,23.84,0,0,0,41.069,10.413V7.363a.85.85,0,1,0-1.7,0V30.028H16.777V1.7H39.37V3.4a.85.85,0,1,0,1.7,0V1.416A1.418,1.418,0,0,0,39.653,0H16.494a1.418,1.418,0,0,0-1.416,1.416v28.9a1.418,1.418,0,0,0,1.416,1.416h5.26c-.062.7-.095,1.4-.095,2.111A23.869,23.869,0,0,0,45.5,57.681a.85.85,0,1,0,0-1.7A22.168,22.168,0,0,1,23.358,33.839c0-.712.036-1.416.1-2.111h3.078a19.074,19.074,0,0,0,23.2,20.712v4.144A1.417,1.417,0,0,0,51.159,58H51.2a19.117,19.117,0,0,0,11.789-4.57.85.85,0,1,0-1.1-1.291,17.415,17.415,0,0,1-10.445,4.151V39.78h16.51a17.248,17.248,0,0,1-3.473,9.6.85.85,0,1,0,1.357,1.023A18.943,18.943,0,0,0,69.661,39.54a1.422,1.422,0,0,0-.4-1.029ZM44.651,33.839V51.2a17.381,17.381,0,0,1-16.4-19.47h11.4a1.418,1.418,0,0,0,1.416-1.416V17.035a17.274,17.274,0,0,1,3.582-.555V33.839Zm6.507,4.241A1.418,1.418,0,0,0,49.742,39.5v11.2a17.286,17.286,0,0,1-3.392.506V34.688H62.86a17.278,17.278,0,0,1-.506,3.392Z",
    transform: "translate(-15.078 0)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46847",
    "data-name": "Pfad 46847",
    d: "M69.483,40.468a4.3,4.3,0,0,0-2.858-2.139,5.546,5.546,0,0,0-4.459,1.2,2.561,2.561,0,0,1,.95-2.078.85.85,0,1,0-1.02-1.359,4.167,4.167,0,0,0-1.615,3.147,5.377,5.377,0,0,0-4.043-.905,4.3,4.3,0,0,0-2.858,2.139A7.348,7.348,0,0,0,53.3,46.43a9.336,9.336,0,0,0,3.075,4.385,5.957,5.957,0,0,0,3.588,1.34,4.5,4.5,0,0,0,.931-.1,4.186,4.186,0,0,0,.637-.188,4.175,4.175,0,0,0,.637.188,5.572,5.572,0,0,0,4.519-1.244,9.337,9.337,0,0,0,3.075-4.385A7.349,7.349,0,0,0,69.483,40.468Zm-1.329,5.414c-.981,2.884-3.561,4.95-5.635,4.513a2.5,2.5,0,0,1-.606-.213.85.85,0,0,0-.763,0,2.5,2.5,0,0,1-.606.213c-2.072.438-4.653-1.629-5.634-4.513a5.749,5.749,0,0,1,.147-4.574,2.589,2.589,0,0,1,1.733-1.317,2.746,2.746,0,0,1,.568-.058,4.983,4.983,0,0,1,3.535,1.9.85.85,0,0,0,1.278,0,4.573,4.573,0,0,1,4.1-1.843,2.589,2.589,0,0,1,1.733,1.317A5.75,5.75,0,0,1,68.153,45.883Z",
    transform: "translate(-48.536 -31.849)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46848",
    "data-name": "Pfad 46848",
    d: "M126.544,199.174h-8.155a.85.85,0,1,0,0,1.7h8.155a.85.85,0,0,0,0-1.7Z",
    transform: "translate(-105.932 -176.611)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46849",
    "data-name": "Pfad 46849",
    d: "M56,200.873H60.35a.85.85,0,1,0,0-1.7H56a.85.85,0,1,0,0,1.7Z",
    transform: "translate(-50.612 -176.611)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46850",
    "data-name": "Pfad 46850",
    d: "M56,230.859H71.224a.85.85,0,0,0,0-1.7H56a.85.85,0,0,0,0,1.7Z",
    transform: "translate(-50.612 -203.2)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46851",
    "data-name": "Pfad 46851",
    d: "M175.092,306.579h-7.7a.85.85,0,1,0,0,1.7h7.7a.85.85,0,1,0,0-1.7Z",
    transform: "translate(-149.381 -271.849)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46852",
    "data-name": "Pfad 46852",
    d: "M175.092,333.579h-7.7a.85.85,0,1,0,0,1.7h7.7a.85.85,0,1,0,0-1.7Z",
    transform: "translate(-149.381 -295.791)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46853",
    "data-name": "Pfad 46853",
    d: "M203.467,360.579h-4.078a.85.85,0,0,0,0,1.7h4.078a.85.85,0,1,0,0-1.7Z",
    transform: "translate(-177.756 -319.732)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35559",
    "data-name": "Gruppe 35559",
    transform: "translate(-329.708 -2893.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#2ecf96",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,12.413V14.5H6.583l6.144-6.144L10.644,6.27Zm9.838-5.671a.553.553,0,0,0,0-.783l-1.3-1.3a.553.553,0,0,0-.783,0L11.238,5.675l2.083,2.083,1.017-1.017Z",
    transform: "translate(369.5 2936.504)",
    fill: "#2ecf96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro3);
export default __webpack_public_path__ + "static/media/Pro3.225476a3a6f6fc17fa98127eefec2902.svg";
export { ForwardRef as ReactComponent };